webpackJsonp([279576734446906],{

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(46);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Lessons = function (_React$Component) {
	  _inherits(Lessons, _React$Component);
	
	  function Lessons(props) {
	    _classCallCheck(this, Lessons);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  Lessons.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Smidge'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'A collection of Lilo Rocks'
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Squish'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Now knows what the monkeys says'
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Ba'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Is the very best'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        'Go back to the homepage'
	      )
	    );
	  };
	
	  return Lessons;
	}(_react2.default.Component);
	
	exports.default = Lessons;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-family-index-js-445de1cf3e01f93c424c.js